import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 26v32l12.31-4.78h24.76l-1.07-4H17.56l-.7.27L10 52.15V26h32v23.22l4-1.07V22H10c-2.2 0-3.99 1.79-4 4ZM32.9 12.63l.54 2h16.4l-.54-2H32.9ZM33.45 19.2h16.4l-.53-2h-16.4l.53 2Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M28.1 6a3.32 3.32 0 0 0-3.32 3.33V20h3V9.33c0-.18.15-.33.32-.33H55v22.67l-6.57-2.46-.43-.16v3.2L58 36V6H28.1ZM35.65 31H15.69v.1l.5 1.9h19.99l-.53-2ZM15.69 36.53l.52 1.97H36.2l-.53-2H15.69v.03ZM36.32 44v-.03L35.8 42H15.81l.53 2h19.98Z"
        }
      )
    ]
  }
);
export {
  t as GetInTouch
};
